import { connect } from 'react-redux';
import ArticleList from '../articleList';
import createArticleProps from '../../../utils/recentPublications/createArticleProps';
import { panelType } from '../../../../shared/constants';
import createArticleEvents from '../../../utils/trackers/createArticleEvents';

const getSelectedRecentPublications = (recentPublications = {}) => {
  const { data } = recentPublications;
  return data && data.scopusDocuments && data.scopusDocuments.length
    ? data.scopusDocuments.map(createArticleProps)
    : [];
};

const mapStateToProps = (state) => {
  const { authors: { data, index: authorIndex } } = state;
  const recentPublications = getSelectedRecentPublications(data[authorIndex]);
  const articles = recentPublications.map((props, publicationIndex) => {
    const {
      contentType, documentType, documentSubtype, pii, doi,
    } = props;
    const eventData = createArticleEvents('author-panel',
      {
        contentType,
        documentType,
        documentSubtype,
      },
      { pii, doi });

    return {
      ...props,
      key: props.doi,
      articlePreviewPanel: panelType.recentPublicationsArticlePreview,
      articlePreviewProps: {
        authorIndex,
        publicationIndex,
      },
      eventData,
    };
  });

  return {
    articles,
  };
};

export default connect(mapStateToProps)(ArticleList);
